import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTradeModalOpen } from "../../store/Slices/globalSymbolSlice";
import TradeModal from "../../components/modal/trading/TradingModal";
import { setSymbol } from "../../store/Slices/symbolSlice";
import { ThemeContext } from "../../context/ThemeContext";

const WatchlistTrade = () => {
    const dispatch = useDispatch();
    const { orderPanelOpen } = useSelector(state => state.globalSymbol);
    const { darkMode } = useContext(ThemeContext);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const symbolName = urlParams.get("symbolName");
        const symbolId = urlParams.get("symbolId");

        if (symbolName && symbolId) {
            dispatch(setSymbol({ symbolId, symbolName }));
            dispatch(setTradeModalOpen(true));
        }
    }, [dispatch]);


    const handleCloseCreateOrderPanel = () => {
        dispatch(setTradeModalOpen(false));
        setTimeout(() => {
            window.close();
        }, 1000);
    };


    return (
        <>
            {orderPanelOpen && <TradeModal open={orderPanelOpen} onClose={handleCloseCreateOrderPanel} showCloseButton={false} />}
        </>
    );
};

export default WatchlistTrade;
